import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;
export const UnorderList = styled.ul`
  color: #15aee5;
`;

export const LinkType = styled.span`
  font-style: italic;
  color: #474747;
`;
